var _defs, _path, _path2, _path3, _path4, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefitsLine3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 652.05 341.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d1b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illu_Linie_3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.28,2.67C4.69,52.06,48.74,85.72,90,106.07a320.21,320.21,0,0,0,67.39,24.29c26.69,6.33,53.91,7.43,81.14,4.48s53.89-9.21,80.75-14.27c29.1-5.48,58.52-9.24,88.19-7.91,32.77,1.47,65.56,8.89,96.17,20.62,25.27,9.68,49.35,23.1,69.82,40.9C592.9,191.08,608.78,212,621,234.64c13.56,25.1,21,52.67,24.08,80.94.88,7.94,1.45,15.9,1.83,23.88.15,3.2,5.15,3.22,5,0-1.4-29.4-5.65-58.87-16.71-86.3a224.64,224.64,0,0,0-42.29-67c-38.34-41.9-93.68-64.67-148.7-74.42-30.75-5.45-62-5.41-92.88-1.4-27.63,3.57-54.74,10-82.13,14.92-27.18,4.91-54.79,7.94-82.39,5.14-24.37-2.48-48.41-9.48-71.15-18.42-23.45-9.21-46.32-21.16-66-37C31.46,60.43,15.32,41.87,8.48,19.19A82.2,82.2,0,0,1,5.28,2.67C5-.51,0-.54.28,2.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.07,47.18A201,201,0,0,0,81.75,79.69c14.41,8.25,29.69,14.85,45.17,20.79,8.4,3.22,16.87,6.25,25.32,9.32a2.5,2.5,0,0,0,1.33-4.82c-14.89-5.4-29.84-10.7-44.33-17.1A237.62,237.62,0,0,1,65.55,63.32,187,187,0,0,1,42.61,43.64c-2.28-2.28-5.81,1.25-3.54,3.54Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M539.12,172.3c16.83,9.3,32.13,21.45,44.06,36.59a114.15,114.15,0,0,1,8.45,12.35c1.64,2.76,6,.25,4.32-2.53-9.88-16.6-23.74-30.51-39.53-41.54A163.12,163.12,0,0,0,541.64,168c-2.82-1.56-5.34,2.75-2.52,4.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.36,237.28a64.55,64.55,0,0,1,7.16,12.33c1.65,3.68,3.13,7.45,4.48,11.26a2.56,2.56,0,0,0,3.08,1.74,2.51,2.51,0,0,0,1.74-3.07c-3.09-8.71-6.6-17.33-12.14-24.78a2.58,2.58,0,0,0-3.42-.9,2.52,2.52,0,0,0-.9,3.42Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 620.62,
    cy: 268.01,
    r: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 623.45,
    cy: 275.75,
    r: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsLine3);
export default __webpack_public_path__ + "static/media/benefits_line_3.72772fed131850348082b96008797e7e.svg";
export { ForwardRef as ReactComponent };